$('.featured_coll_slider').slick({
  dots: false,
  infinite: true,
  arrows:true,  
  slidesToShow: 4, 
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 798,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


$('.testimonial_slider').slick({
  dots: false,
  infinite: false,
  arrows:true,  
  slidesToShow: 3, 
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 798,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});


  $(".close_pop_strike").click(function(){
  $(".strike_popup_cover").addClass("hide_pop_strike");
  $("body").addClass("remove_scroll");
});